import { Route, Routes, useLocation, useNavigate } from "react-router-dom";

import SignInPage from "@/app/signin/page";
import DefaultLayout from "@/layouts/defualt_layout";
import routes from "./routes";

// Hydrogen
// Dashboard
import AnalyticsDashboard from "@/app/(hydrogen)/analytics/page";

// Appointment
import AppointmentList from "@/app/(hydrogen)/appointment/list/page";
import AppointmentDashboard from "@/app/(hydrogen)/appointment/page";

import CrmDashboard from "@/app/(hydrogen)/crm/page";

// ecommerce
import EcommerceDashboard from "@/app/(hydrogen)/ecommerce/page";

// ecommerce - products
import EcommerceProductsEdit from "@/app/(hydrogen)/ecommerce/products/[slug]/edit/page";
import EcommerceProductsDetails from "@/app/(hydrogen)/ecommerce/products/[slug]/page";
import EcommerceProductsCreate from "@/app/(hydrogen)/ecommerce/products/create/page";
import EcommerceProducts from "@/app/(hydrogen)/ecommerce/products/page";

// ecommerce - categories
import EcommerceCategoriesEdit from "@/app/(hydrogen)/ecommerce/categories/[id]/edit/page";
import EcommerceCategoriesCreate from "@/app/(hydrogen)/ecommerce/categories/create/page";
import EcommerceCategories from "@/app/(hydrogen)/ecommerce/categories/page";

// ecommerce - orders
import EcommerceOrdersEdit from "@/app/(hydrogen)/ecommerce/orders/[id]/edit/page";
import EcommerceOrdersDetails from "@/app/(hydrogen)/ecommerce/orders/[id]/page";
import EcommerceOrdersCreate from "@/app/(hydrogen)/ecommerce/orders/create/page";
import EcommerceOrders from "@/app/(hydrogen)/ecommerce/orders/page";

// ecommerce - orders
import EcommerceCart from "@/app/(hydrogen)/ecommerce/cart/page";
import EcommerceCheckout from "@/app/(hydrogen)/ecommerce/checkout/page";
import EcommerceReviews from "@/app/(hydrogen)/ecommerce/reviews/page";
import EcommerceShop from "@/app/(hydrogen)/ecommerce/shop/page";

// support
import {
    default as SupportCategory,
    default as SupportMessageDetail,
} from "@/app/(hydrogen)/support/inbox/[id]/page";
import SupportInbox from "@/app/(hydrogen)/support/inbox/page";
import SupportDashboard from "@/app/(hydrogen)/support/page";
import SupportSnippets from "@/app/(hydrogen)/support/snippets/page";
import SupportTemplate from "@/app/(hydrogen)/support/templates/page";

// invoice
import InvoiceEdit from "@/app/(hydrogen)/invoice/[id]/edit/page";
import InvoiceDetails from "@/app/(hydrogen)/invoice/[id]/page";
import InvoiceBuilder from "@/app/(hydrogen)/invoice/builder/page";
import InvoiceCreate from "@/app/(hydrogen)/invoice/create/page";
import InvoicePage from "@/app/(hydrogen)/invoice/page";

import ExecutiveDashboard from "@/app/(hydrogen)/executive/page";
import FinancialDashboard from "@/app/(hydrogen)/financial/page";

// job
import JobBoardFeed from "@/app/(hydrogen)/job-board/feed/page";
import JobBoardDashboard from "@/app/(hydrogen)/job-board/page";

// file
import FileManager from "@/app/(hydrogen)/file-manager/page";

// role permission
import RolePermission from "@/app/(hydrogen)/roles-permissions/page";

// Image viewer
import ImageViewer from "@/app/(hydrogen)/image-viewer/page";

// Search
import SearchFlight from "@/app/(hydrogen)/search/flight/page";
import SearchNft from "@/app/(hydrogen)/search/nft/page";
import SearchRealState from "@/app/(hydrogen)/search/real-estate/page";

// Image viewer
import POS from "@/app/(hydrogen)/point-of-sale/page";

// logistics
import LogisticsCustomerProfile from "@/app/(hydrogen)/logistics/customer-profile/page";
import LogisticsDashboard from "@/app/(hydrogen)/logistics/page";
import LogisticsShipmentEdit from "@/app/(hydrogen)/logistics/shipments/[id]/edit/page";
import LogisticsShipmentDetails from "@/app/(hydrogen)/logistics/shipments/[id]/page";
import LogisticsShipmentCreate from "@/app/(hydrogen)/logistics/shipments/create/page";
import LogisticsShipmentList from "@/app/(hydrogen)/logistics/shipments/page";
import LogisticsTracking from "@/app/(hydrogen)/logistics/tracking/[id]/page";

import HydrogenDashboard from "@/app/(hydrogen)/page";
import ProjectDashboard from "@/app/(hydrogen)/project/page";
import SocialMediaDashboard from "@/app/(hydrogen)/social-media/page";
import EcommerceLayout from "@/layout/ecommerce_layout";

// Widgets
import WidgetsEmailTemplate from "@/app/(hydrogen)/email-templates/page";
import WidgetsCard from "@/app/(hydrogen)/widgets/cards/page";
import WidgetsCharts from "@/app/(hydrogen)/widgets/charts/page";
import WidgetsIcon from "@/app/(hydrogen)/widgets/icons/page";
import WidgetsMap from "@/app/(hydrogen)/widgets/maps/page";

// forms
import NewsLetter from "@/app/(hydrogen)/forms/newsletter/page";
import Billing from "@/app/(hydrogen)/forms/profile-settings/billing/page";
import Integration from "@/app/(hydrogen)/forms/profile-settings/integration/page";
import ProfileSettingsLayout from "@/app/(hydrogen)/forms/profile-settings/layout";
import NotificationPreference from "@/app/(hydrogen)/forms/profile-settings/notification/page";
import AccountSettings from "@/app/(hydrogen)/forms/profile-settings/page";
import Password from "@/app/(hydrogen)/forms/profile-settings/password/page";
import PersonalInformation from "@/app/(hydrogen)/forms/profile-settings/profile/page";
import Team from "@/app/(hydrogen)/forms/profile-settings/team/page";
import MultiStepLayoutTwo from "@/app/multi-step/layout";
import MultiStep from "@/app/multi-step/page";

// Tables
import TablesBasic from "@/app/(hydrogen)/tables/basic/page";
import TablesCollapsible from "@/app/(hydrogen)/tables/collapsible/page";
import TablesDragAndDrop from "@/app/(hydrogen)/tables/dnd/page";
import TablesEnhanced from "@/app/(hydrogen)/tables/enhanced/page";
import TablesPagination from "@/app/(hydrogen)/tables/pagination/page";
import TablesPinning from "@/app/(hydrogen)/tables/pinning/page";
import TablesResizable from "@/app/(hydrogen)/tables/resizable/page";
import TablesSearch from "@/app/(hydrogen)/tables/search/page";
import TablesStickyHeader from "@/app/(hydrogen)/tables/sticky-header/page";

// Pages
import Blank from "@/app/(hydrogen)/blank/page";
import Profile from "@/app/(hydrogen)/profile/page";
import AccessDenied from "@/components/other_pages/access-denied/page";
import ComingSoon from "@/components/other_pages/coming-soon/page";
import Maintenance from "@/components/other_pages/maintenance/page";
import NotFound from "@/components/other_pages/not-found/page";
import Welcome from "@/components/other_pages/welcome/page";
import OtherPagesLayout from "@/layouts/other_pages_layout";

// Authentication
import AuthLogin from "@/app/auth/login/page";
import EventsPage from "@/app/events/page";
import EventDetailsPage from "@/app/events/details";
import EventPaymentsPage from "@/app/events/payments";
import PaymentsPage from "@/app/payments/page";
import CategoryPage from "@/app/category/page";
import CityPage from "@/app/city/page";
import CountryPage from "@/app/country/page";
import HotelsPage from "@/app/hotels/page";
import VenuesPage from "@/app/venues/page";
import CreateEditVenuePage from "@/app/venues/create";
import VenuePaymentsPage from "@/app/venues/payments";
import GuestHousesPage from "@/app/guest-houses/page";
import EntityPage from "@/app/entity/page";
import EntityDetailsPage from "@/app/entity/details/page";
import RolePermissionsPage from "@/app/roles-permissions/page";
import UserDetailPage from "@/app/user/details/page";
import UserPage from "@/app/user/page";

import PermissionsLists from "@/config/PermissionsLists";
import instanceAxios from "@/Core/Client/AxiosConfig";
import { PrivateRoutes } from "@/utils/privateRoute";
import useAuthStore from "@Stores/AuthStore";
import axios from "axios";
import { useEffect } from "react";

function Routers() {
    const { logOut, isAuthorized, auth } = useAuthStore((s) => s);
    const navigate = useNavigate();
    const location = useLocation();

    function authCheck() {
        if (!isAuthorized) {
            if (
                ![
                    routes.auth.login,
                    routes.auth.forgotPassword,
                    routes.auth.otp,
                ].includes(location.pathname) ||
                auth?.user == null
            ) {
                logOut();

                navigate(routes.auth.login);
            }
        }
    }

    useEffect(() => {
        authCheck();

        instanceAxios.interceptors.response.use(
            (res) => {
                return res;
            },
            (error) => {
                if (axios.isAxiosError(error)) {
                    const { response } = error;

                    switch (response?.status) {
                        case 401:
                            // UnAuthorized, LogOut
                            navigate(routes.auth.login);
                            logOut();
                            break;

                        case 403:
                            logOut();

                            if (import.meta.env.PROD) {
                                navigate(routes.auth.login);
                            } else {
                                navigate(routes.dashboards.index);
                            }
                            break;

                        case 500:
                            // navigate(route.auth.login);
                            // console.log("500", route.dashboards.index);
                            break;

                        default:
                            break;
                    }
                }

                return Promise.reject(error);
                // return error;
            },
        );

        if (auth == undefined || !isAuthorized) navigate(routes.auth.login);
        // else if (isAuthorized && isVerified == false) {
        //     navigate(routes.auth.otp);
        // }
    }, [isAuthorized, auth]);

    return (
        <Routes>
            <Route path={routes.auth.login} element={<AuthLogin />} />

            <Route path={routes.signIn} element={<SignInPage />} />

            {/* other Pages */}
            <Route element={<OtherPagesLayout isSocialActive={false} />}>
                <Route path={"*"} element={<NotFound />} />
            </Route>

            <Route element={<OtherPagesLayout />}>
                <Route path={routes.welcome} element={<Welcome />} />
                <Route path={routes.comingSoon} element={<ComingSoon />} />
                <Route path={routes.accessDenied} element={<AccessDenied />} />
                <Route path={routes.notFound} element={<NotFound />} />
                <Route path={"*"} element={<NotFound />} />
                <Route path={routes.maintenance} element={<Maintenance />} />
                <Route path={routes.blank} element={<Blank />} />
            </Route>

            <Route element={<MultiStepLayoutTwo />}>
                <Route path={routes.multiStep} element={<MultiStep />} />
            </Route>

            {/* hydrogen  */}
            <Route element={<DefaultLayout />}>
                <Route path={routes.dashboards.index} element={<HydrogenDashboard />} />

                <Route path={routes.events.index}>
                    <Route path="" element={<PrivateRoutes noContent={true} permission={PermissionsLists.Events.List} children={<EventsPage />} />} />

                    <Route path={routes.events.details(":id")} element={<EventDetailsPage />} />

                    <Route
                        path={routes.events.payments(":id")}
                        element={
                            <PrivateRoutes
                                noContent={true}
                                permission={PermissionsLists.Venues.Payments}>
                                <EventPaymentsPage />
                            </PrivateRoutes>
                        } />
                </Route>

                <Route path={routes.payments.index}>
                    <Route path="" element={<PrivateRoutes noContent={true} permission={PermissionsLists.Payments.List} children={<PaymentsPage />} />} />

                    <Route path={routes.payments.details(":id")} element={<PaymentsPage />} />
                </Route>

                <Route path={routes.entity.index}>
                    <Route path="" element={<PrivateRoutes noContent={true} permission={PermissionsLists.Entity.List} children={<EntityPage />} />} />

                    <Route path={routes.entity.details(":id")} element={<EntityDetailsPage />} />
                </Route>

                {/* Config */}
                <Route
                    path={routes.country}
                    element={
                        <PrivateRoutes
                            noContent={true}
                            permission={PermissionsLists.Country.List}
                        >
                            <CountryPage />
                        </PrivateRoutes>
                    }
                />
                <Route
                    path={routes.city}
                    element={
                        <PrivateRoutes
                            noContent={true}
                            permission={PermissionsLists.City.List}
                        >
                            <CityPage />
                        </PrivateRoutes>
                    }
                />
                <Route
                    path={routes.category.index}
                    element={
                        <PrivateRoutes
                            noContent={true}
                            permission={PermissionsLists.Category.List}
                        >
                            <CategoryPage />
                        </PrivateRoutes>
                    }
                />
                <Route
                    path={routes.hotels.index}
                    element={
                        <PrivateRoutes
                            noContent={true}
                            permission={PermissionsLists.Hotels.List}
                        >
                            <HotelsPage />
                        </PrivateRoutes>
                    }
                />

                <Route
                    path={routes.venues.index}
                    element={
                        <PrivateRoutes
                            noContent={true}
                            permission={PermissionsLists.Venues.List}>
                            <VenuesPage />
                        </PrivateRoutes>
                    }
                />

                <Route
                    path={routes.venues.create}
                    element={
                        <PrivateRoutes
                            noContent={true}
                            permission={PermissionsLists.Venues.Create}>
                            <CreateEditVenuePage />
                        </PrivateRoutes>
                    } />

                <Route
                    path={routes.venues.edit(":id")}
                    element={
                        <PrivateRoutes
                            noContent={true}
                            permission={PermissionsLists.Venues.Edit}>
                            <CreateEditVenuePage />
                        </PrivateRoutes>
                    } />

                <Route
                    path={routes.venues.payments(":id")}
                    element={
                        <PrivateRoutes
                            noContent={true}
                            permission={PermissionsLists.Venues.Payments}>
                            <VenuePaymentsPage />
                        </PrivateRoutes>
                    } />

                <Route
                    path={routes.guestHouses.index}
                    element={
                        <PrivateRoutes
                            noContent={true}
                            permission={PermissionsLists.GuestHouses.List}
                        >
                            <GuestHousesPage />
                        </PrivateRoutes>
                    }
                />

                <Route
                    path={routes.role}
                    element={
                        <PrivateRoutes
                            noContent={true}
                            permission={PermissionsLists.Role.List}
                        >
                            <RolePermissionsPage />
                        </PrivateRoutes>
                    }
                />

                <Route
                    path={routes.user.index}
                    element={
                        <PrivateRoutes
                            noContent={true}
                            permission={PermissionsLists.User.List}
                        >
                            <UserPage />
                        </PrivateRoutes>
                    }
                />

                <Route
                    path={routes.user.details(":id")}
                    element={
                        <PrivateRoutes
                            noContent={true}
                            permission={PermissionsLists.User.List}
                        >
                            <UserDetailPage />
                        </PrivateRoutes>
                    }
                />

                {/* appointment */}
                <Route
                    path={routes.appointment.dashboard}
                    element={<AppointmentDashboard />}
                />
                <Route
                    path={routes.appointment.appointmentList}
                    element={<AppointmentList />}
                />

                <Route
                    path={routes.executive.dashboard}
                    element={<ExecutiveDashboard />}
                />
                <Route
                    path={routes.project.dashboard}
                    element={<ProjectDashboard />}
                />
                <Route path={routes.crm.dashboard} element={<CrmDashboard />} />
                <Route
                    path={routes.financial.dashboard}
                    element={<FinancialDashboard />}
                />
                <Route
                    path={routes.jobBoard.dashboard}
                    element={<JobBoardDashboard />}
                />
                <Route
                    path={routes.jobBoard.jobFeed}
                    element={<JobBoardFeed />}
                />
                <Route
                    path={routes.support.dashboard}
                    element={<JobBoardDashboard />}
                />
                {/* Support */}
                <Route
                    path={routes.support.dashboard}
                    element={<SupportDashboard />}
                />
                <Route path={routes.support.inbox} element={<SupportInbox />} />
                <Route
                    path={routes.support.supportCategory(":id")}
                    element={<SupportCategory />}
                />
                <Route
                    path={routes.support.messageDetails(":id")}
                    element={<SupportMessageDetail />}
                />
                <Route
                    path={routes.support.snippets}
                    element={<SupportSnippets />}
                />
                <Route
                    path={routes.support.templates}
                    element={<SupportTemplate />}
                />
                {/* SupportEnd */}

                {/* ECommerce  */}
                <Route element={<EcommerceLayout />}>
                    <Route
                        path={routes.eCommerce.dashboard}
                        element={<EcommerceDashboard />}
                    />
                    <Route
                        path={routes.eCommerce.products}
                        element={<EcommerceProducts />}
                    />
                    <Route
                        path={routes.eCommerce.createProduct}
                        element={<EcommerceProductsCreate />}
                    />
                    <Route
                        path={routes.eCommerce.productDetails(":id")}
                        element={<EcommerceProductsDetails />}
                    />
                    <Route
                        path={routes.eCommerce.ediProduct(":id")}
                        element={<EcommerceProductsEdit />}
                    />

                    <Route
                        path={routes.eCommerce.categories}
                        element={<EcommerceCategories />}
                    />
                    <Route
                        path={routes.eCommerce.createCategory}
                        element={<EcommerceCategoriesCreate />}
                    />
                    <Route
                        path={routes.eCommerce.editCategory(":id")}
                        element={<EcommerceCategoriesEdit />}
                    />
                    <Route
                        path={routes.eCommerce.orders}
                        element={<EcommerceOrders />}
                    />
                    <Route
                        path={routes.eCommerce.createOrder}
                        element={<EcommerceOrdersCreate />}
                    />
                    <Route
                        path={routes.eCommerce.orderDetails(":id")}
                        element={<EcommerceOrdersDetails />}
                    />
                    <Route
                        path={routes.eCommerce.editOrder(":id")}
                        element={<EcommerceOrdersEdit />}
                    />
                    <Route
                        path={routes.eCommerce.reviews}
                        element={<EcommerceReviews />}
                    />
                    <Route
                        path={routes.eCommerce.shop}
                        element={<EcommerceShop />}
                    />
                    <Route
                        path={routes.eCommerce.cart}
                        element={<EcommerceCart />}
                    />
                    <Route
                        path={routes.eCommerce.checkout}
                        element={<EcommerceCheckout />}
                    />
                </Route>
                {/* ECommerce End */}
                {/* Invoice */}
                <Route path={routes.invoice.home} element={<InvoicePage />} />
                <Route
                    path={routes.invoice.create}
                    element={<InvoiceCreate />}
                />
                <Route
                    path={routes.invoice.details(":id")}
                    element={<InvoiceDetails />}
                />
                <Route
                    path={routes.invoice.edit(":id")}
                    element={<InvoiceEdit />}
                />
                <Route
                    path={routes.invoice.builder}
                    element={<InvoiceBuilder />}
                />
                {/* Invoice End */}
                {/* Logistics  */}
                <Route
                    path={routes.logistics.shipmentList}
                    element={<LogisticsShipmentList />}
                />
                <Route
                    path={routes.logistics.createShipment}
                    element={<LogisticsShipmentCreate />}
                />
                <Route
                    path={routes.logistics.customerProfile}
                    element={<LogisticsCustomerProfile />}
                />
                <Route
                    path={routes.logistics.editShipment(":id")}
                    element={<LogisticsShipmentEdit />}
                />
                <Route
                    path={routes.logistics.shipmentDetails(":id")}
                    element={<LogisticsShipmentDetails />}
                />
                <Route
                    path={routes.logistics.tracking(":id")}
                    element={<LogisticsTracking />}
                />
                {/* Logistics End */}
                <Route
                    path={routes.socialMedia.dashboard}
                    element={<SocialMediaDashboard />}
                />
                <Route
                    path={routes.logistics.dashboard}
                    element={<LogisticsDashboard />}
                />
                <Route
                    path={routes.analytics}
                    element={<AnalyticsDashboard />}
                />
                {/* file */}
                <Route path={routes.file.manager} element={<FileManager />} />

                {/* Role */}
                <Route
                    path={routes.rolesPermissions}
                    element={<RolePermission />}
                />

                {/* Image Viewer */}
                <Route path={routes.imageViewer} element={<ImageViewer />} />

                {/* Point of Sales */}
                <Route path={routes.pos.index} element={<POS />} />

                {/* RealState */}
                <Route
                    path={routes.searchAndFilter.realEstate}
                    element={<SearchRealState />}
                />

                {/* Flight */}
                <Route
                    path={routes.searchAndFilter.flight}
                    element={<SearchFlight />}
                />

                {/* Nft */}
                <Route
                    path={routes.searchAndFilter.nft}
                    element={<SearchNft />}
                />

                {/* Widgets */}
                <Route path={routes.widgets.cards} element={<WidgetsCard />} />
                <Route
                    path={routes.widgets.charts}
                    element={<WidgetsCharts />}
                />
                <Route path={routes.widgets.icons} element={<WidgetsIcon />} />
                <Route path={routes.widgets.maps} element={<WidgetsMap />} />
                <Route path={routes.widgets.maps} element={<WidgetsMap />} />
                <Route
                    path={routes.emailTemplates}
                    element={<WidgetsEmailTemplate />}
                />

                {/* Forms */}
                <Route element={<ProfileSettingsLayout />}>
                    <Route
                        path={routes.forms.profileSettings}
                        element={<AccountSettings />}
                    />
                    <Route
                        path={routes.forms.notificationPreference}
                        element={<NotificationPreference />}
                    />
                    <Route path={routes.forms.billing} element={<Billing />} />
                    <Route path={routes.forms.team} element={<Team />} />
                    <Route
                        path={routes.forms.integration}
                        element={<Integration />}
                    />
                    <Route
                        path={routes.forms.password}
                        element={<Password />}
                    />
                    <Route
                        path={routes.forms.personalInformation}
                        element={<PersonalInformation />}
                    />
                    <Route
                        path={routes.forms.newsletter}
                        element={<NewsLetter />}
                    />
                </Route>

                {/* Table */}
                <Route path={routes.tables.basic} element={<TablesBasic />} />
                <Route
                    path={routes.tables.collapsible}
                    element={<TablesCollapsible />}
                />
                <Route
                    path={routes.tables.enhanced}
                    element={<TablesEnhanced />}
                />
                <Route
                    path={routes.tables.stickyHeader}
                    element={<TablesStickyHeader />}
                />
                <Route
                    path={routes.tables.pagination}
                    element={<TablesPagination />}
                />
                <Route path={routes.tables.search} element={<TablesSearch />} />
                <Route
                    path={routes.tables.resizable}
                    element={<TablesResizable />}
                />
                <Route
                    path={routes.tables.pinning}
                    element={<TablesPinning />}
                />
                <Route
                    path={routes.tables.dnd}
                    element={<TablesDragAndDrop />}
                />
                <Route path={routes.profile} element={<Profile />} />
            </Route>

            {/* other pages */}
            {/* <Route></Route> */}
        </Routes>
    );
}

export default Routers;